export const SHOPCART_ADD_EVENT = 'REDUX_SHOPCART_ADD_EVENT';
export const SHOPCART_ADD_EVENT_WITH_TOURHOLD = 'REDUX_SHOPCART_ADD_EVENT_WITH_TOURHOLD';
export const SHOPCART_REMOVE_EVENT = 'REDUX_SHOPCART_REMOVE_EVENT';
export const SHOPCART_ADD_TOUR_PRODUCT = 'REDUX_SHOPCART_ADD_TOUR_PRODUCT';

export const SHOPCART_REMOVE_TOUR_PRODUCT = 'REDUX_SHOPCART_REMOVE_TOUR_PRODUCT';
export const SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD = 'REDUX_SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD';
export const SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING = 'REDUX_SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING';

export const SHOPCART_RESET_STATE = 'REDUX_SHOPCART_RESET_STATE';
export const SHOPCART_RESET_STATE_WITH_TOURHOLD_LOADING = 'REDUX_SHOPCART_RESET_STATE_WITH_TOURHOLD_LOADING';
export const SHOPCART_REMOVE_SINGLE_TOUR_WITH_TOURHOLD_LOADING = 'REDUX_SHOPCART_REMOVE_SINGLE_TOUR_WITH_TOURHOLD_LOADING';


export const SHOPCART_SET_TOUR_PRODUCT_QUANTITY = 'REDUX_SHOPCART_SET_TOUR_PRODUCT_QUANTITY';
export const SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD = 'REDUX_SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD';
export const SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING = 'REDUX_SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING';
export const SHOPCART_ERROR = 'REDUX_SHOPCART_ERROR';
export const SHOPCART_RESET_ERROR = 'REDUX_SHOPCART_RESET_ERROR';
export const SHOPCART_APPLYCOUPON_TO_EVENTS = 'REDUX_SHOPCART_APPLYCOUPON_TO_EVENTS';
export const SHOPCART_APPLYCOUPON_TO_GATICKETS = 'REDUX_SHOPCART_APPLYCOUPON_TO_GATICKETS';
export const REMOVE_COUPON = 'REDUX_SAGA_REMOVE_COUPON';


export const SHOPCART_ADD_GIFTCARD = 'REDUX_SHOPCART_ADD_GIFTCARD';
export const SHOPCART_DELETE_GIFTCARD = 'REDUX_SHOPCART_DELETE_GIFTCARD';
export const SHOPCART_UPDATE_GIFTCARD = 'REDUX_SHOPCART_UPDATE_GIFTCARD';
export const SHOPCART_COUPONAPPLIED_RESET = 'REDUX_SHOPCART_COUPONAPPLIED_RESET';
export const SHOPCART_RESET_STATE_WITH_UNIQUECOUPONHOLD = 'REDUX_SHOPCART_RESET_STATE_WITH_UNIQUECOUPONHOLD';
export const SHOPCART_COUPONREMOVE_RESET = 'REDUX_SHOPCART_COUPONREMOVE_RESET';


export const SHOPCART_APPLY_MEMBERSHIP_COSTRATES_ON_EVENTS = 'REDUX_SHOPCART_APPLY_MEMBERSHIP_COSTRATES_ON_EVENTS';


export const SHOPCART_REMOVE_GATICKET_COUPONS = 'REDUX_SHOPCART_REMOVE_GATICKET_COUPONS';
export const SHOPCART_REMOVE_GIFTCARDS = 'REDUX_SHOPCART_REMOVE_GIFTCARDS';
export const SHOPCART_REMOVE_ALL_COUPONS = 'REDUX_SHOPCART_REMOVE_ALL_COUPONS';
export const SHOPCART_RESET_GIFTCARDS = 'REDUX_SHOPCART_RESET_GIFTCARDS';
export const SHOPCART_RESET_MEMBERSHIP = 'REDUX_SHOPCART_RESET_MEMBERSHIP';
export const SHOPCART_RESET_IDME = 'REDUX_SHOPCART_RESET_IDME';
export const SHOPCART_UPDATE_MEMBERSHIPEMAIL = 'REDUX_SHOPCART_UPDATE_MEMBERSHIPEMAIL';

export const SHOPCART_APPLY_DONATION = 'REDUX_SHOPCART_APPLY_DONATION';
export const SHOPCART_RESET_DONATION = 'REDUX_SHOPCART_RESET_DONATION';
export const UPDATE_DONATION_POPUP_INCREASE = 'REDUX_UPDATE_DONATION_POPUP_INCREASE';
export const RESET_DONATION_POPUP_INCREASE = 'REDUX_RESET_DONATION_POPUP_INCREASE';

export const SHOPCART_ADD_PERSON_MEMBERSHIPTYPE = 'REDUX_SHOPCART_ADD_PERSON_MEMBERSHIPTYPE';
export const SHOPCART_REMOVE_PERSON_MEMBERSHIPTYPE = 'REDUX_SHOPCART_REMOVE_PERSON_MEMBERSHIPTYPE';
export const SHOPCART_ADD_ADDON_MEMBERSHIP = 'REDUX_SHOPCART_ADD_ADDON_MEMBERSHIP';
export const SHOPCART_ADD_MEMBERSHIP_PACKAGE = 'REDUX_SHOPCART_ADD_MEMBERSHIP_PACKAGE';
export const SHOPCART_RESET_MEMBERSHIP_PACKAGE = 'REDUX_SHOPCART_RESET_MEMBERSHIP_PACKAGE';
export const SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE = 'REDUX_SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE';
export const SHOPCART_REMOVECOUPON_FROM_MEMBERSHIPTYPE = 'REDUX_SHOPCART_REMOVECOUPON_FROM_MEMBERSHIPTYPE';

export const SHOPCART_GATICKET_ADD = 'REDUX_SHOPCART_GATICKET_ADD';
export const SHOPCART_GATICKET_REMOVE = 'REDUX_SHOPCART_GATICKET_REMOVE';
export const SHOPCART_GATICKET_UPDATE_QUANTITY = 'REDUX_SHOPCART_GATICKET_UPDATE_QUANTITY';
export const SHOPCART_RESET_GATICKET = 'REDUX_SHOPCART_RESET_GATICKET';

export const SHOPCART_SET_MANAGEMYBOOKING = 'REDUX_SHOPCART_SET_MANAGEMYBOOKING';
export const SHOPCART_SET_REFUNDTYPE = 'REDUX_SHOPCART_SET_REFUNDTYPE';
export const SHOPCART_SET_ADDITIONALBOOKING_AMOUNT = 'REDUX_SHOPCART_SET_ADDITIONALBOOKING_AMOUNT';
export const SHOPCART_SET_MMB_AMOUNT_TO_PAY = 'REDUX_SHOPCART_SET_MMB_AMOUNT_TO_PAY';
export const SHOPCART_SET_ENTERED_AMOUNT_TO_PAY = 'REDUX_SHOPCART_SET_ENTERED_AMOUNT_TO_PAY';
export const SHOPCART_APPLY_MEMBER_COSTRATE = 'REDUX_SHOPCART_APPLY_MEMBER_COSTRATE';

export const SHOPCART_APPLY_IDME_COSTRATES_ON_EVENTS = 'REDUX_SHOPCART_APPLY_IDME_COSTRATES_ON_EVENTS';

export const SHOPCART_ADD_ORDER_PRODUCT = 'REDUX_SHOPCART_ADD_ORDER_PRODUCT';
export const SHOPCART_UPDATE_ORDER_PRODUCT = 'REDUX_SHOPCART_UPDATE_ORDER_PRODUCT';
export const SHOPCART_UPDATE_ORDER_PRODUCTS = 'REDUX_SHOPCART_UPDATE_ORDER_PRODUCTS';
export const SHOPCART_DELETE_ORDER_PRODUCT = 'REDUX_SHOPCART_DELETE_ORDER_PRODUCT';
export const SHOPCART_RESET_ORDER_PRODUCTS = 'REDUX_SHOPCART_RESET_ORDER_PRODUCTS';

export const SHOPCART_VERIFY_VALID_MEMBER = 'REDUX_SHOPCART_VERIFY_VALID_MEMBER';
export const SHOPCART_SHOW_TRANSACTION_FEE = 'REDUX_SHOPCART_SHOW_TRANSACTION_FEE';

export const SHOPCART_UPDATE_DONATION_PRODUCT = 'REDUX_SHOPCART_UPDATE_DONATION_PRODUCT';
export const SHOPCART_DELETE_DONATION_PRODUCT = 'REDUX_SHOPCART_DELETE_DONATION_PRODUCT';
export const SHOPCART_RESET_DONATION_PRODUCT = 'REDUX_SHOPCART_RESET_DONATION_PRODUCT';

export const SHOPCART_SET_MMB_HAS_PAID = 'REDUX_SHOPCART_SET_HAS_PAID';

export const actionShopCartAddEventWithTourHold = (dispatch, event, cartevent, organizationID, groupSize, paymentOption, amountSelected, isEditEvent) => {
    dispatch({ type: SHOPCART_ADD_EVENT_WITH_TOURHOLD, payload: { event: event, cartevent: cartevent }, organizationID, groupSize, paymentOption, amountSelected, isEditEvent });
};

export const actionShopCartAddEvent = (dispatch, event) => {
    dispatch({ type: SHOPCART_ADD_EVENT, payload: event });
};

export const actionShopCartRemoveEventAction = (dispatch, TourEventID) => {
    dispatch({ type: SHOPCART_REMOVE_EVENT, payload: TourEventID });
};

export const actionShopCartAddTour = (dispatch, TourEventID, tourprduct) => {
    dispatch({ type: SHOPCART_ADD_TOUR_PRODUCT, payload: { TourEventID: TourEventID, tourprduct: tourprduct } });
};

export const actionShopCartRemoveTour = (dispatch, TourEventID, TourProductID) => {
    dispatch({ type: SHOPCART_REMOVE_TOUR_PRODUCT, payload: { TourEventID: TourEventID, TourProductID: TourProductID } });
};

export const actionShopCartRemoveTourWithTourHold = (dispatch, CartEvent, TourEventID, TourProductID) => {
    dispatch({ type: SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING, payload: { CartEvent: CartEvent, TourEventID: TourEventID, TourProductID: TourProductID } });
};

export const actionShopCartResetState = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_STATE });
};

export const actionShopCartResetStateWithTourHold = (dispatch, CartEvent) => {
    dispatch({ type: SHOPCART_RESET_STATE_WITH_TOURHOLD_LOADING, payload: CartEvent });
};

export const actionShopCartRemoveSingleTourWithTourHold = (dispatch, CartEvent, TourEventID) => {
    dispatch({ type: SHOPCART_REMOVE_SINGLE_TOUR_WITH_TOURHOLD_LOADING, payload: { CartEvent: CartEvent, TourEventID: TourEventID } });
};

export const actionShopCartAddProductQuanity = (dispatch, TourEventID, TourProductID, Quantity) => {
    dispatch({ type: SHOPCART_SET_TOUR_PRODUCT_QUANTITY, payload: { TourEventID: TourEventID, TourProductID: TourProductID, Quantity: Quantity } });
};

export const actionShopCartAddProductQuanityWithTourHold = (dispatch, CartEvent, TourEventID, TourProductID, Quantity) => {
    dispatch({ type: SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING, payload: { CartEvent: CartEvent, TourEventID: TourEventID, TourProductID: TourProductID, Quantity: Quantity } });
};

export const actionShopCartApplyCouponCodesToEvents = (dispatch, Coupon, tourProduct, CouponHoldRef) => {
    dispatch({ type: SHOPCART_APPLYCOUPON_TO_EVENTS, payload: Coupon, tourProduct: tourProduct, CouponHoldRef });
};

export const actionRemoveCoupon = (dispatch, TourEventID, TourProductID) => {
    dispatch({ type: REMOVE_COUPON, payload: { TourEventID: TourEventID, TourProductID: TourProductID } });
};

export const actionShopCardAddGiftCard = (dispatch, giftcard) => {
    dispatch({ type: SHOPCART_ADD_GIFTCARD, payload: giftcard });
};

export const actionShopCardDeleteGiftCard = (dispatch, GiftcardHoldRef) => {
    dispatch({ type: SHOPCART_DELETE_GIFTCARD, payload: GiftcardHoldRef });
};

export const actionShopCartUpdateGiftCard = (dispatch, cashless) => {
    dispatch({ type: SHOPCART_UPDATE_GIFTCARD, payload: cashless });
};

export const actionResetCouponAlreadyApplied = (dispatch) => {
    dispatch({ type: SHOPCART_COUPONAPPLIED_RESET });
}

export const actionShopCartResetStateWithUniqueCouponHold = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_STATE_WITH_UNIQUECOUPONHOLD });
};

export const actionResetCouponRemoveReset = (dispatch) => {
    dispatch({ type: SHOPCART_COUPONREMOVE_RESET });
}

export const actionShopCartApplyMembershipOnEvents = (dispatch, costrate, extraitems, memberNo, memberEmail, memberLastName) => {
    dispatch({ type: SHOPCART_APPLY_MEMBERSHIP_COSTRATES_ON_EVENTS, payload: { costrate: costrate, extraitems: extraitems, memberNo: memberNo, memberEmail: memberEmail, memberLastName: memberLastName } });
};

export const actionShopCartValidMember = (dispatch, costrate, memberNo, memberEmail, memberLastName) => {
    dispatch({ type: SHOPCART_VERIFY_VALID_MEMBER, payload: { costrate: costrate, memberNo: memberNo, memberEmail: memberEmail, memberLastName: memberLastName } });
};

export const actionShopCartRemoveCoupons = (dispatch) => {
    dispatch({ type: SHOPCART_REMOVE_ALL_COUPONS });
};

export const actionShopCartRemoveGATicketCoupons = (dispatch, couponCode) => {
    dispatch({ type: SHOPCART_REMOVE_GATICKET_COUPONS, payload: couponCode })
}

export const actionShopCartRemoveGiftcards = (dispatch) => {
    dispatch({ type: SHOPCART_REMOVE_GIFTCARDS });
};

export const actionShopCartResetGiftcards = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_GIFTCARDS });
};

export const actionShopCartResetMembership = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_MEMBERSHIP });
};

export const actionShopCartResetIDME = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_IDME });
};

export const actionShopCartUpdateMembershipEmail = (dispatch, newEmail) => {
    dispatch({ type: SHOPCART_UPDATE_MEMBERSHIPEMAIL, payload: newEmail });
};

export const actionShopCartApplyDonation = (dispatch, productID, productName, price, othersAmount, useAlternateMerchantOnline) => {
    dispatch({ type: SHOPCART_APPLY_DONATION, payload: { productID: productID, productName: productName, price: price, othersAmount: othersAmount, useAlternateMerchantOnline: useAlternateMerchantOnline } });
};

export const actionShopCartResetDonation = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_DONATION })
};

export const actionShopCartUpdatePopupCounts = (dispatch) => {
    dispatch({ type: UPDATE_DONATION_POPUP_INCREASE })
}

export const actionShopCartResetDonations = (dispatch) => {
    dispatch({ type: RESET_DONATION_POPUP_INCREASE })
}

export const actionShopCartAddMembershipPackage = (dispatch, memberPackage, isRenew) => {
    dispatch({ type: SHOPCART_ADD_MEMBERSHIP_PACKAGE, payload: memberPackage, isRenew: isRenew })
}

export const actionShopCartResetMembershipPackage = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_MEMBERSHIP_PACKAGE })
}

export const actionShopCartRemoveCouponFromMembershiptype = (dispatch, memberTypeID) => {
    dispatch({ type: SHOPCART_REMOVECOUPON_FROM_MEMBERSHIPTYPE, payload: memberTypeID })
}

export const actionShopCartAddGATicket = (dispatch, Products) => {
    dispatch({ type: SHOPCART_GATICKET_ADD, payload: Products })
}

export const actionShopCartRemoveGATicket = (dispatch, ProductID) => {
    dispatch({ type: SHOPCART_GATICKET_REMOVE, payload: { ProductID } })
}

export const actionShopCartGATicketUpdateQuanity = (dispatch, ProductID, Quantity) => {
    dispatch({ type: SHOPCART_GATICKET_UPDATE_QUANTITY, payload: { ProductID, Quantity } })
}

export const actionShopCartResetGATicket = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_GATICKET })
}

export const actionShopCartSetManageMyBooking = (dispatch, managebooking, managebookingmodifytickets) => {
    dispatch({ type: SHOPCART_SET_MANAGEMYBOOKING, payload: { managebooking: managebooking, managebookingmodifytickets: managebookingmodifytickets } })
}

export const actionShopCartSetRefundType = (dispatch, refundType) => {
    dispatch({ type: SHOPCART_SET_REFUNDTYPE, payload: { refundType: refundType } })
}

export const actionShopCartSetAdditionalBookingAmount = (dispatch, amount) => {
    dispatch({ type: SHOPCART_SET_ADDITIONALBOOKING_AMOUNT, payload: { amount: amount } })
}

export const actionShopCartSetMmbAmountToPay = (dispatch, amounttopay) => {
    dispatch({ type: SHOPCART_SET_MMB_AMOUNT_TO_PAY, payload: { amounttopay: amounttopay } })
}

export const actionShopCartSetEnteredAmountToPay = (dispatch, amount) => {
    dispatch({ type: SHOPCART_SET_ENTERED_AMOUNT_TO_PAY, payload: { enteredAmountToPay: amount } })
}

export const actionShopCartApplyMemberCostrate = (dispatch, costrate, memberNo, memberEmail, memberLastName) => {
    dispatch({ type: SHOPCART_APPLY_MEMBER_COSTRATE, payload: { costrate: costrate, memberNo: memberNo, memberEmail: memberEmail, memberLastName: memberLastName } });
};

export const actionShopCartApplyidmeCostratesOnEvents = (dispatch, costrate, extraitems) => {
    dispatch({ type: SHOPCART_APPLY_IDME_COSTRATES_ON_EVENTS, payload: { costrate: costrate, extraitems: extraitems } });
};

export const actionShopCartResetError = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_ERROR })
}

export const actionAddOrderProduct = (dispatch, foodProduct) => {
    dispatch({ type: SHOPCART_ADD_ORDER_PRODUCT, payload: foodProduct })
};

export const actionUpdateOrderProduct = (dispatch, foodProduct) => {
    dispatch({ type: SHOPCART_UPDATE_ORDER_PRODUCT, payload: foodProduct })
};

export const actionUpdateOrderProducts = (dispatch, foodProducts) => {
    dispatch({ type: SHOPCART_UPDATE_ORDER_PRODUCTS, payload: foodProducts })
};

export const actionDeleteOrderProduct = (dispatch, foodProduct) => {
    dispatch({ type: SHOPCART_DELETE_ORDER_PRODUCT, payload: foodProduct })
};

export const actionShopcartResetOrderProducts = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_ORDER_PRODUCTS })
}

export const actionShopCartShowTransFee = (dispatch, check) => {
    dispatch({ type: SHOPCART_SHOW_TRANSACTION_FEE, payload: check })
};

export const actionShopCartUpdateDonationProduct = (dispatch, donationProducts) => {
    dispatch({ type: SHOPCART_UPDATE_DONATION_PRODUCT, payload: donationProducts });
}

export const actionShopCartDeleteDonationProduct = (dispatch, productID) => {
    dispatch({ type: SHOPCART_DELETE_DONATION_PRODUCT, payload: productID });
}

export const actionShopCartResetDonationProduct = (dispatch) => {
    dispatch({ type: SHOPCART_RESET_DONATION_PRODUCT });
}

export const actionShopCartSetMMBHasPaid = (dispatch, MMBHasPaid) => {
    dispatch({ type: SHOPCART_SET_MMB_HAS_PAID, payload: { MMBHasPaid: MMBHasPaid } });
}

